export type KnowledgeScopeFilter = 'all' | 'team' | 'mine';

interface ScopeOption {
  id: KnowledgeScopeFilter;
  label: string;
  count: number;
}

interface KnowledgeScopePillsProps {
  value: KnowledgeScopeFilter;
  options: ScopeOption[];
  onChange: (scope: KnowledgeScopeFilter) => void;
}

export const KnowledgeScopePills = ({
  value,
  options,
  onChange,
}: KnowledgeScopePillsProps) => (
  <div
    className="inline-flex flex-wrap gap-0.5 p-1 rounded-lg bg-[#EAEEF0]/70 border border-[#E4E9EC]"
    role="tablist"
    aria-label="Filter knowledge by scope">
    {options.map(option => {
      const selected = value === option.id;
      return (
        <button
          key={option.id}
          type="button"
          role="tab"
          aria-selected={selected}
          onClick={() => onChange(option.id)}
          className={`px-3 py-1.5 rounded-md text-[13px] font-medium transition-all ${
            selected
              ? 'bg-white text-[#252F33] font-semibold shadow-sm ring-1 ring-[#E4E9EC]'
              : 'text-[#768D95] hover:text-[#252F33]'
          }`}>
          {option.label}
          <span
            className={`text-[11px] ml-1 tabular-nums ${
              selected ? 'text-[#007CA0]' : 'opacity-60'
            }`}>
            {option.count}
          </span>
        </button>
      );
    })}
  </div>
);
